module.exports = __webpack_public_path__ + "static/img/coupon_title.1f33d5e5.png";